module.exports = __webpack_public_path__ + "static/img/tile-2.d11bb9e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tile-2.jpeg
// module id = 1536
// module chunks = 180